import { BillingConfigurationDetailsFormKeyProps } from "../../components/billingTypeConfigureTable/modelsAndSchemas/Models";
import {
  DOCUMENT_SITE_CORE_KEY,
  REGEX_NAME_WITH_SPACES_AND_DASHES,
} from "../../helpers/constants";
import { isNotEmpty } from "../../helpers/utils";
import {
  ClientContact,
  CreateClientFormKey as ProgramTemplateFormKey,
  PurchaseOrder,
} from "./modelsAndSchemas/Models";

export const filterPurchaseOrders = (
  orderList: PurchaseOrder[],
  filters: PurchaseOrder,
) => {
  return orderList.filter((order) => {
    return Object.keys(filters).every((key) => {
      const filterValue = filters[key];
      const orderValue = order[key];
      if (!filterValue) return true; // Skip filters with empty values
      const filterValueLower = String(filterValue).toLowerCase();
      const orderValueLower = String(orderValue).toLowerCase();
      return orderValueLower?.toString().includes(filterValueLower);
    });
  });
};

export const isContactBelongCurrentClient = (contact: ClientContact) => {
  return contact.isAttachedToCurrentClient || isNotEmpty(contact.contactType);
};

export const getCurrentClientContactList = (
  clientContactsData: ClientContact[],
) => {
  return clientContactsData.filter(
    (contact) => contact.isAttachedToCurrentClient,
  );
};
export const getParentClientContactList = (
  clientContactsData: ClientContact[],
) => {
  return clientContactsData.filter(
    (contact) => !contact.isAttachedToCurrentClient,
  );
};

export const nameWithSpacesAndDashesValidation = {
  onInput: (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    target.value = target.value.replace(REGEX_NAME_WITH_SPACES_AND_DASHES, "");
  },
};

export const isDocumentTypeContract = (type: string) =>
  type === DOCUMENT_SITE_CORE_KEY.documentTypeContract;

export const getBillingConfigurationDetailsFormKeys = (
  formIdPrefix: string,
): BillingConfigurationDetailsFormKeyProps => {
  return {
    billingTypeIdKey: `${formIdPrefix}.${ProgramTemplateFormKey.billingTypeId}`,
    schedulePeriodKey: `${formIdPrefix}.${ProgramTemplateFormKey.schedulePeriod}`,
    feeKey: `${formIdPrefix}.${ProgramTemplateFormKey.feeWithFormat}`,
    scheduleKey: `${formIdPrefix}.${ProgramTemplateFormKey.schedules}`,
    feePercentageKey: `${formIdPrefix}.${ProgramTemplateFormKey.feePercentage}`,
    amountWithFormatKey: `${formIdPrefix}.${ProgramTemplateFormKey.amountWithFormat}`,
    amountKey: `${formIdPrefix}.${ProgramTemplateFormKey.amount}`,
    scheduleFrequencyKey: `${formIdPrefix}.${ProgramTemplateFormKey.scheduleFrequency}`,
    milestoneKey: `${formIdPrefix}.${ProgramTemplateFormKey.milestones}`,
    activitiesKey: `${formIdPrefix}.${ProgramTemplateFormKey.activities}`,
    billingSchedulesKey: `${formIdPrefix}.${ProgramTemplateFormKey.billingSchedules}`,
    feePaymentTypeKey: `${formIdPrefix}.${ProgramTemplateFormKey.feePaymentType}`,
    descriptionKey: `${formIdPrefix}.${ProgramTemplateFormKey.description}`,
  };
};
